import React from 'react';
import AppraisalToolPilot from '../../Components/AppraisalToolPilot/AppraisalToolPilot';
import PurposePilot from '../../Components/PurposePilot/PurposePilot';
import Inspection from '../../Components/Inspection/Inspection';
import HelpSection from '../../Components/HelpSection/HelpSection';
import Faqs from '../../Components/Faqs/Faqs';
import DownloadSection from '../../Components/DownloadSection/DownloadSection';

const JLRLanding = () => {
  return (
    <>      
      <main>
        <div className="container">
          <AppraisalToolPilot />
          <PurposePilot />
          <Inspection />
          <HelpSection />
          <Faqs />
          {/* <DownloadSection /> */}
        </div>
      </main>
    </>
  );
}

export default JLRLanding;
